<template>
  <div class="pdf-report-residents">
    <NavBar class="nav--bar" />
    <AuthBySessionExpired class="auth--by--session--expired" />
    <div class="container">
      <b-modal
        id="filter"
        size="lg"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="container">
          <div class="row">
            <div class="col-md-3">
              <label class="m-0">Situação</label>
              <select
                v-model="resident_active"
                class="form-control"
                @change="getResidents"
              >
                <option value="TODOS">TODOS</option>
                <option value="ATIVO">ATIVOS</option>
                <option value="INATIVO">INATIVOS</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="m-0">Residente</label>
              <select v-model="resident_id" class="form-control">
                <option value="">TODOS</option>
                <option
                  v-for="(resident, key) in residents"
                  :key="key"
                  :value="resident.id"
                >
                  {{ String(resident.name).toUpperCase() }} -
                  {{ String(resident.status_type_name).toUpperCase() }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="m-0">Grau</label>
              <select v-model="degree_of_dependence_id" class="form-control">
                <option value="">TODOS</option>
                <option
                  v-for="(typeFilterByGrau, key) in typesFilterByGrau"
                  :key="key"
                  :value="typeFilterByGrau.value"
                >
                  {{ typeFilterByGrau.text }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="m-0">Gênero</label>
              <select v-model="gender_id" class="form-control">
                <option value="">TODOS</option>
                <option
                  v-for="(gender, key) in genders"
                  :key="key"
                  :value="gender.value"
                >
                  {{ gender.text }}
                </option>
              </select>
            </div>
            <div
              class="col-md-4 relatorio-residentes-conteudo-filtro-encerramento"
            >
              <h6 class="m-0">Encerramento de contrato</h6>
              <div class="row m-0">
                <div class="col-md-12">
                  <label class="m-0">Data inicial</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="date_of_the_withdrawal_init"
                  />
                </div>
                <div class="col-md-12">
                  <label class="m-0">Data final</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="date_of_the_withdrawal_end"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-4 relatorio-residentes-conteudo-filtro-cadastro">
              <h6 class="m-0">Cadastro</h6>
              <div class="row m-0">
                <div class="col-md-12">
                  <label class="m-0">Data inicial</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="created_at_init"
                  />
                </div>
                <div class="col-md-12">
                  <label class="m-0">Data final</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="created_at_end"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-4 relatorio-residentes-conteudo-filtro-epoca">
              <h6 class="m-0">Residentes na época</h6>
              <div class="row m-0">
                <div class="col-md-12">
                  <label class="m-0">Mês</label>
                  <input
                    type="month"
                    class="form-control"
                    v-model="at_the_time"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 pb-0">
              <p class="m-0">Filtrar por quais abas?</p>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="geral"
                  v-model="geral"
                  checked
                  disabled
                />
                <label class="form-check-label" for="geral"> GERAL </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="endereco"
                  v-model="endereco"
                  checked
                />
                <label class="form-check-label" for="endereco">
                  Endereço
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="documentos"
                  v-model="documentos"
                  checked
                />
                <label class="form-check-label" for="documentos">
                  Documentos
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="familiares"
                  v-model="familiares"
                  checked
                />
                <label class="form-check-label" for="familiares">
                  Familiares
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="convenios"
                  v-model="convenios"
                  checked
                />
                <label class="form-check-label" for="convenios">
                  Convênios
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="hospedagem"
                  v-model="hospedagem"
                  checked
                />
                <label class="form-check-label" for="hospedagem">
                  Hospedagem
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="encerramento_contrato"
                  v-model="encerramento_contrato"
                  checked
                />
                <label class="form-check-label" for="encerramento_contrato">
                  Encerramento de contrato
                </label>
              </div>
            </div>
            <div class="col-md-12">
              <ErrorsMessages :errors="errors" />
            </div>
            <div class="col-md-12 text-right">
              <v-btn
                :disabled="loading"
                @click="paginate()"
                class="btn-filter"
                type="relief"
                ><i class="fas fa-filter mr-2 text-twenty"></i>
                {{ loading ? "CARREGANDO" : "FILTRAR" }}
              </v-btn>
            </div>
          </div>
        </div>
      </b-modal>
      <div class="row content-filter">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return mb-3" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: RESIDENTES
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="data.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="data.length > 0"
        >
          <h6
            class="mb-0 upper-text worksansr check-text-center"
            v-if="resident_id"
          >
            FILTRANDO:
            <span v-if="resident_id"><strong>RESIDENTE</strong></span>
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="data.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <div class="table-responsive">
          <table
            class="table-always"
            v-for="(resident, residentKey) in data"
            :key="residentKey"
          >
            <thead>
              <tr>
                <td>
                  <div class="header-space">
                    <div class="row">
                      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                        <img
                          v-if="rest_home_logo_url"
                          class="rest_home_logo_url"
                          :src="rest_home_logo_url"
                        />
                        <div v-if="!rest_home_logo_url" class="ml-1">
                          <strong class="text-uppercase">{{
                            rest_home_name
                          }}</strong>
                        </div>
                      </div>
                      <div
                        class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex align-items-center"
                      >
                        <img
                          v-if="resident.photo_url"
                          class="resident_photo_url"
                          :src="resident.photo_url"
                        />
                        <img
                          v-if="!resident.photo_url"
                          class="resident_photo_url"
                          :src="require('../../assets/user.png')"
                        />
                        <ResidentDataPrintDefault :resident_id="resident.id" />
                      </div>
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                      >
                        <img
                          class="logo"
                          src="https://sistemclinupload.s3.amazonaws.com/logo.png"
                          width="180"
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="content">
                    <div class="row data-inside-avoid" v-if="geral">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
                      >
                        <h6 class="mb-0">INFORMAÇÕES</h6>
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>NOME:</strong> {{ resident.name }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>GÊNERO:</strong>
                        {{ resident.gender_name }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>DATA DE NASCIMENTO:</strong>
                        {{ formatDate(resident.date_of_birth, false) }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>STATUS:</strong>
                        {{ resident.status_type_name }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>APELIDO:</strong>
                        {{ resident.nickname }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>GRAU DE DEPENDÊNCIA:</strong>
                        {{ resident.degree_of_dependence_name }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>PATOLOGIA (DOENÇA):</strong>
                        {{ resident.pathology }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>ALERGIAS DIVERSAS:</strong>
                        {{ resident.miscellaneous_allergies }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>TIPO DE ALIMENTAÇÃO:</strong>
                        {{ resident.type_of_food }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>NATURALIDADE:</strong>
                        {{ resident.naturalness }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>ESTADO CIVIL:</strong>
                        {{
                          resident.marital_status &&
                          resident.marital_status.name
                        }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>RELIGIÃO:</strong>
                        {{ resident.religion }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>PROFISSÃO:</strong>
                        {{ resident.profession }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>ESCOLARIDADE:</strong>
                        {{ resident.schooling }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>NOME DO PAI:</strong>
                        {{ resident.fathers_name }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>NOME DA MÃE:</strong>
                        {{ resident.mothers_name }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>CÔNJUGE:</strong>
                        {{ resident.spouse }}
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>OBSERVAÇÕES:</strong>
                        {{ resident.comments }}
                      </div>
                    </div>
                    <div class="row data-inside-avoid" v-if="documentos">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
                      >
                        <h6 class="mb-0">DOCUMENTOS</h6>
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>CPF:</strong>
                        {{ resident.cpf }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>RG:</strong>
                        {{ resident.rg }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>ORGÃO EXPEDIDOR:</strong>
                        {{ resident.issuing_body }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>DATA DE EMISSÃO:</strong>
                        {{ resident.rg }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>NÚMERO DO CARTÃO SUS:</strong>
                        {{ resident.SUS_card_number }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>NÚMERO DO BENEFÍCIO DO INSS:</strong>
                        {{ resident.INSS_benefit_number }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>TIPO DE BENEFÍCIO INSS:</strong>
                        {{ resident.type_of_INSS_benefit }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>SITUAÇÃO DO BENEFÍCIO DO INSS:</strong>
                        {{ resident.INSS_benefit_status }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>VALOR DO BENEFÍCIO DO INSS:</strong>
                        {{ formatPrice(resident.INSS_benefit_amount) }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>DATA DA ATUALIZAÇÃO DO INSS:</strong>
                        {{ formatDate(resident.INSS_update_date, false) }}
                      </div>
                      <div
                        class="col-md-12"
                        v-if="
                          resident.documents && resident.documents.length > 0
                        "
                      >
                        <div class="pt-0 pb-0 text-center border">
                          <h6 class="mb-0">DOCUMENTOS ANEXADOS</h6>
                        </div>
                        <div
                          v-for="(documentResident, key) in resident.documents"
                          :key="key"
                        >
                          <div class="pt-0 pb-0 upper-text worksansr">
                            <strong>NOME:</strong> {{ documentResident.name }}
                          </div>
                          <hr class="m-0" />
                        </div>
                      </div>
                    </div>
                    <div class="row data-inside-avoid" v-if="endereco">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
                      >
                        <h6 class="mb-0">ENDEREÇO</h6>
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>CEP:</strong>
                        {{ resident.cep }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>ENDEREÇO:</strong>
                        {{ resident.address }}, {{ resident.number_address }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>BAIRRO:</strong>
                        {{ resident.neighborhood }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>CIDADE:</strong>
                        {{ resident.city }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>ESTADO:</strong>
                        {{ resident.uf && resident.uf.name }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>REFERÊNCIA:</strong>
                        {{ resident.reference }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>COMPLEMENTO:</strong>
                        {{ resident.complement }}
                      </div>
                    </div>
                    <div class="row data-inside-avoid" v-if="hospedagem">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
                      >
                        <h6 class="mb-0">HOSPEDAGEM</h6>
                      </div>
                      <div
                        v-if="resident.type_of_hosting"
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        {{
                          resident.type_of_hosting
                            .billing_type_of_hosting_type_name
                        }}
                        {{ resident.type_of_hosting.name }}
                        <strong>- Valor da mensalidade:</strong>
                        {{ formatPrice(resident.income_monthly_fee) }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>DATA DA HOSPEDAGEM:</strong>
                        {{ formatDate(resident.date_of_reception, false) }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong class="mr-2">LEITO DO RESIDENTE:</strong>
                        <span>
                          <strong>Número:</strong>
                          {{ resident.bed && resident.bed.number }}
                        </span>
                        <strong class="mr-2">-</strong>
                        <span>
                          <strong>Andar:</strong>
                          {{ resident.bed && resident.bed.walk }}
                        </span>
                        <strong class="mr-2">-</strong>
                        <span>
                          <strong>Ala/setor:</strong>
                          {{ resident.bed && resident.bed.ward_or_sector }}
                        </span>
                        <strong class="mr-2">-</strong>
                        <span>
                          <strong>Quarto:</strong>
                          {{ resident.bed && resident.bed.bedroom }}
                        </span>
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>MOTIVO DA HOSPEDAGEM:</strong>
                        {{ resident.reason_for_the_reception }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>VENCIMENTO DO CONTRATO:</strong>
                        {{ formatDate(resident.date_end_contract, false) }}
                      </div>
                    </div>
                    <div
                      class="row data-inside-avoid"
                      v-if="encerramento_contrato"
                    >
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
                      >
                        <h6 class="mb-0">ENCERRAMENTO DO CONTRATO</h6>
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>DATA DO ENCERRAMENTO DO CONTRATO:</strong>
                        {{ formatDate(resident.date_of_the_withdrawal, false) }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>MOTIVO DO ENCERRAMENTO DO CONTRATO:</strong>
                        {{ resident.reason_for_the_withdrawal }}
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                      >
                        <strong>OUTROS MOTIVOS:</strong>
                        {{ resident.other_reasons }}
                      </div>
                    </div>
                    <div
                      v-if="
                        familiares &&
                        resident.customer_has_resident &&
                        resident.customer_has_resident.length > 0
                      "
                      class="row data-inside-avoid"
                    >
                      <div class="col-md-12 pt-0 pb-0 text-center border">
                        <h6 class="mb-0">FAMILIARES</h6>
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                        v-for="(item, key) in resident.customer_has_resident"
                        :key="key"
                      >
                        <div class="pt-0 pb-0 upper-text worksansr">
                          <strong>NOME:</strong> {{ item.name }}
                        </div>
                        <div class="pt-0 pb-0 upper-text worksansr">
                          <strong>E-MAIL:</strong> {{ item.email }}
                        </div>
                        <div class="pt-0 pb-0 upper-text worksansr">
                          <strong>GRAU DE PARENTESTO:</strong>
                          {{ item.type_of_customer_name }}
                        </div>
                        <div class="pt-0 pb-0 upper-text worksansr">
                          <strong>1º TELEFONE:</strong>
                          {{ item.first_phone }}
                        </div>
                        <div class="pt-0 pb-0 upper-text worksansr">
                          <strong>2º TELEFONE:</strong>
                          {{ item.second_phone }}
                        </div>
                        <div class="pt-0 pb-0 upper-text worksansr">
                          <strong>RESPONSÁVEL FINANCEIRO?:</strong>
                          {{ item.responsible_for_payment ? "SIM" : "NÃO" }}
                        </div>
                        <hr class="m-0" />
                      </div>
                    </div>
                    <div
                      v-if="
                        convenios &&
                        resident.agreement &&
                        resident.agreement.length > 0
                      "
                      class="row m-0 data-inside-avoid"
                    >
                      <div class="col-md-12 pt-0 pb-0 text-center border">
                        <h6 class="mb-0">CONVÊNIOS</h6>
                      </div>

                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                        v-for="(item, key) in resident.agreement"
                        :key="key"
                      >
                        <div class="row">
                          <div
                            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                          >
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>NOME:</strong>
                              {{ item.covenant_name }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>TIPO/NOME DO PLANO:</strong>
                              {{ item.type_plan_name }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>NOME DO TITULAR:</strong>
                              {{ item.name }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>TELEFONE DA CENTRAL:</strong>
                              {{ item.exchange_phone }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>TELEFONE:</strong> {{ item.phone }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>CELULAR:</strong>
                              {{ item.cell_phone }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>OBSERVAÇÕES:</strong>
                              {{ item.note }}
                            </div>
                          </div>
                          <div
                            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                          >
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>CEP:</strong>
                              {{ item.cep }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>ENDEREÇO:</strong>
                              {{ item.address }},
                              {{ item.number_address }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>BAIRRO:</strong>
                              {{ item.neighborhood }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>CIDADE:</strong>
                              {{ item.city }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>ESTADO:</strong>
                              {{ item.uf }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>REFERÊNCIA:</strong>
                              {{ item.reference }}
                            </div>
                            <div class="pt-0 pb-0 upper-text worksansr">
                              <strong>COMPLEMENTO:</strong>
                              {{ item.complement }}
                            </div>
                          </div>
                        </div>
                        <hr class="m-0" />
                      </div>
                    </div>
                  </div>
                  <div class="footer text-center">
                    <hr class="mb-1 border-black" />
                    <h6 class="mb-0 worksansr">
                      (Assinatura eletrônica)
                      <strong>
                        {{
                          professionalClassCouncilValue({
                            id: user.professional_class_council_id,
                            name: user.name,
                            profile: user.profile_name,
                            cpf: user.cpf,
                            office: user.office,
                            value: user.professional_class_council_value,
                          })
                        }}
                        <span class="ml-1">
                          - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
                        </span>
                      </strong>
                    </h6>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <div class="footer-space">&nbsp;</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ResidentDataPrintDefault from "../../components/resident/ResidentDataPrintDefault";

import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import routes from "../../routes";

import {
  formatDate,
  formatPrice,
  formatDateToMonthYear,
  professionalClassCouncilValue,
} from "../../lib/format";

import { getAge } from "../../lib/getAgeByDate";

import { userData } from "../../lib/functions";

import moment from "moment";

export default {
  name: "ReportsResidents",

  components: {
    NavBar,
    AuthBySessionExpired,
    ResidentDataPrintDefault,
    ErrorsMessages,
  },

  data() {
    return {
      resident_active: "ATIVO",
      resident_id: "",
      degree_of_dependence_id: "",
      gender_id: "",
      created_at_init: "",
      created_at_end: "",
      date_of_the_withdrawal_init: "",
      date_of_the_withdrawal_end: "",
      at_the_time: "",
      residents: [],
      data: [],
      user: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      loading: false,
      errors: [],

      typesFilterByGrau: [
        { value: "1", text: "GRAU 1" },
        { value: "2", text: "GRAU 2" },
        { value: "3", text: "GRAU 3" },
      ],

      genders: [
        { value: "1", text: "FEMININO" },
        { value: "2", text: "MASCULINO" },
      ],

      geral: true,
      endereco: true,
      documentos: true,
      familiares: true,
      convenios: true,
      hospedagem: true,
      encerramento_contrato: true,

      user_allow_home_care: 0,
      rest_home_allow_home_care: 0,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getAge,
    moment,
    formatDate,
    formatPrice,
    formatDateToMonthYear,
    professionalClassCouncilValue,

    async retrieve() {
      const { user } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.user_allow_home_care = user.allow_home_care;
      this.rest_home_allow_home_care = user.rest_home_allow_home_care;

      await this.getResidents();

      if (this.errors.length == 0 && this.resident_id) {
        await this.paginate();
      }

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },

    async getResidents() {
      try {
        let { resident_active } = this;

        let status = "ATIVO";

        if (resident_active == "TODOS") {
          status = "ALL";
        } else if (resident_active == "INATIVO") {
          status = "INATIVO";
        } else if (!["TODOS", "ATIVO", "INATIVO"].includes(resident_active)) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        const {
          resident_id,
          resident_active,
          degree_of_dependence_id,
          gender_id,
          geral,
          endereco,
          documentos,
          familiares,
          convenios,
          hospedagem,
          encerramento_contrato,
          created_at_init,
          created_at_end,
          date_of_the_withdrawal_init,
          date_of_the_withdrawal_end,
          at_the_time,
        } = this;

        let params = {
          resident_id,
          resident_active,
          degree_of_dependence_id,
          gender_id,
          geral,
          endereco,
          documentos,
          familiares,
          convenios,
          hospedagem,
          encerramento_contrato,
          created_at_init,
          created_at_end,
          date_of_the_withdrawal_init,
          date_of_the_withdrawal_end,
          at_the_time,
        };

        const response = await api.get("/rest-home/report/residents", {
          params,
        });

        const { data, error, errors } = response.data;

        if (error) {
          this.data = [];
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToPrint: () => window.print(),

    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.pdf-report-residents p {
  font-weight: 100 !important;
}
.pdf-report-residents .text-amount {
  font-size: 13px;
}

.pdf-report-residents .date-amount {
  font-size: 13px;
}

.pdf-report-residents .header,
.pdf-report-residents .header-space {
  height: auto;
}

.pdf-report-residents .footer,
.pdf-report-residents .footer-space {
  height: 50px;
}

.pdf-report-residents .header {
  position: fixed;
  top: 0;
}

.pdf-report-residents .logo {
  width: 100%;
  height: 50px;
  object-fit: contain;
}

.pdf-report-residents .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-report-residents .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}

.pdf-report-residents .table-always,
.pdf-report-residents td,
.pdf-report-residents th {
  width: 100% !important;
  cursor: auto !important;
}

.pdf-report-residents th {
  background-color: #f5f5f5;
}

.pdf-report-residents .medicine-name {
  font-size: 14px;
}

.pdf-report-residents small {
  font-size: 12px;
}

.relatorio-residentes-conteudo-filtro-cadastro {
  background-color: #d8fce1;
}

.relatorio-residentes-conteudo-filtro-encerramento {
  background-color: #facfd3;
}

.relatorio-residentes-conteudo-filtro-epoca {
  background-color: #b4eef7;
}

@media print {
  .pdf-report-residents .table-always {
    width: 100% !important;
    border: none !important;
  }

  .pdf-report-residents .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .pdf-report-residents .content {
    page-break-inside: avoid !important;
  }

  .pdf-report-residents .content-movimentation {
    page-break-inside: avoid !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }

  .pdf-report-residents .table-always {
    page-break-before: always !important;
  }

  .pdf-report-residents .header,
  .pdf-report-residents .header-space {
    height: auto;
  }

  body {
    margin: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-report-residents button {
    display: none;
  }

  .pdf-report-residents .nav--bar {
    display: none !important;
  }

  .pdf-report-residents .auth--by--session--expired {
    display: none !important;
  }

  .pdf-report-residents .content-filter {
    display: none;
  }

  .pdf-report-residents .data-inside-avoid {
    page-break-inside: avoid !important;
  }
}
</style>
